import { useRef } from 'react'
import { useRemoteVideoTileState } from 'amazon-chime-sdk-component-library-react'
import useRemoteParticipants from '@hooks/useRemoteParticipants'
import useRemoteParticipantSpeaking from '@hooks/useRemoteParticipantSpeaking'
import { useMeetingStore } from '@stores/meeting'
import { VideoAspectRatioBox } from '@components/molecules/VideoAspectRatioBox/VideoAspectRatioBox'
import { RemoteVideoContainer, DraggableLocalVideo, LocalVideoFullScreen } from './components'
import { useRemoteParticipantDisplay } from './hooks/useRemoteParticipantDisplay'

export const MeetingVideoGridDesktop = () => {
  const { tiles: allRemoteVideoTiles } = useRemoteVideoTileState()
  const { hasRemoteParticipants } = useRemoteParticipants()
  const isRemoteSpeaking = useRemoteParticipantSpeaking()
  const localAttendeeId = useMeetingStore((state) => state.attendeeId)

  const containerRef = useRef<HTMLDivElement>(null)

  // Guard: Only use video tiles when we know who the local user is
  const remoteVideoTiles = localAttendeeId ? allRemoteVideoTiles : []
  const hasRemoteVideo = remoteVideoTiles.length > 0

  const { name: participantName, initials: participantInitials } = useRemoteParticipantDisplay()

  return (
    <div className="hidden md:flex h-full w-full items-center justify-center p-6">
      <div className="relative w-full h-full max-w-screen-2xl">
        <div className="absolute inset-0 flex items-center justify-center">
          <VideoAspectRatioBox className="w-full max-h-full" containerRef={containerRef}>
            {!hasRemoteParticipants ? (
              // Alone: Show local video full screen
              <LocalVideoFullScreen />
            ) : (
              // With participant: Show remote video full screen + local video PiP
              <>
                <RemoteVideoContainer
                  hasRemoteParticipants={hasRemoteParticipants}
                  hasRemoteVideo={hasRemoteVideo}
                  remoteVideoTileId={remoteVideoTiles[0]}
                  isRemoteSpeaking={isRemoteSpeaking}
                  participantName={participantName}
                  participantInitials={participantInitials}
                  isDeparted={false}
                />

                <DraggableLocalVideo containerRef={containerRef} platform="desktop" />
              </>
            )}
          </VideoAspectRatioBox>
        </div>
      </div>
    </div>
  )
}
